import { Space } from 'antd';
import styles from './index.module.less';

interface IProps {
  logo: React.ReactNode;
  title: string;
}

export const HeaderTitleRender = ({ logo, title }: IProps) => {
  return (
    <Space style={{ cursor: 'pointer' }} className={styles.wrap}>
      <div>{logo}</div>
      <div className={styles.projectName}>{title}</div>
    </Space>
  );
};
